module.exports = __webpack_public_path__ + "static/original_scoreboard-d5adfdab9814d541862d5996119c3c60.jpg";